import { types } from 'mobx-state-tree';

export const AppVersion = types
  .model({
    currentAppVersion: types.string,
    newAppVersion: types.maybe(types.string),
    hasNewUpdate: types.boolean,
  })
  .actions(self => ({
    setNewVersionAvailable: (newAppVersion: string) => {
      self.newAppVersion = newAppVersion;
      self.hasNewUpdate = true;
    },
  }));

export default AppVersion;
